module.exports = __webpack_public_path__ + "static/img/st-1.8e46a04.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/st-1.jpg
 ** module id = 584
 ** module chunks = 2
 **/